import { useTranslation } from 'react-i18next';
import { useAuth } from '@/auth/AuthContext';

/**
 * The pre-T85 scaffold content, unchanged, for every role that doesn't have a real widget set
 * registered yet in `dashboardRegistry.tsx` (all 6 non-Admin roles this pass — T85 only wires
 * Admin). `DashboardPage` renders the shared `<h1>` above this; the welcome/role-context line
 * lives here since only the placeholder needs it.
 */
export function PlaceholderDashboardWidgets() {
  const { t } = useTranslation();
  const { user } = useAuth();

  return (
    <>
      <div className="fa-dashboard__hero">
        {user && (
          <span className="fa-dashboard__avatar" aria-hidden="true">
            {user.fullName.trim().charAt(0).toUpperCase()}
          </span>
        )}
        {user && (
          <p className="fa-dashboard__welcome">
            {t('dashboard.welcome', { name: user.fullName })}
            {' — '}
            {t('dashboard.roleLabel', { role: user.role })}
          </p>
        )}
      </div>
      <div className="fa-dashboard__placeholder">
        <span className="fa-dashboard__placeholder-icon" aria-hidden="true">
          &#128202;
        </span>
        <p>{t('dashboard.placeholder')}</p>
      </div>
    </>
  );
}
